import React, { useState, useEffect } from 'react';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroSlides = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1698854633001-39d4e6806316",
    alt: "Close-up of sizzling beef tacos with melted cheese, fresh cilantro, diced onions, and lime wedges on rustic wooden serving board with steam rising",
    title: "Real Flavors, Real Fresh",
    subtitle: "Experience authentic Mexican street food crafted with 100% halal ingredients",
    cta: "Order Now"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1701407312283-48083fa2c94d",
    alt: "Vibrant restaurant interior with warm amber lighting, wooden tables, colorful Mexican wall art, hanging plants, and comfortable booth seating creating welcoming atmosphere",
    title: "Where Street Meets Clean",
    subtitle: "Immerse yourself in the authentic vibe of Mexican street food culture",
    cta: "Explore Ambience"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1626552232455-105d118b37ea",
    alt: "Group of diverse young friends laughing and sharing tacos at restaurant table, with colorful plates of food, drinks, and warm lighting capturing community dining spirit",
    title: "Taste the Authentic, Feel the Vibe",
    subtitle: "Join our community and create unforgettable food memories",
    cta: "Find Location"
  }];


  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides?.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [heroSlides?.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides?.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroSlides?.length) % heroSlides?.length);
  };

  return (
    <section className="relative w-full h-screen overflow-hidden bg-gradient-to-br from-primary/10 to-accent/10">
      {/* Hero Slides */}
      <div className="relative w-full h-full">
        {heroSlides?.map((slide, index) =>
        <div
          key={slide?.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
          index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'}`
          }>

            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent z-10" />
            <Image
            src={slide?.image}
            alt={slide?.alt}
            className="w-full h-full object-cover" />

            
            {/* Content Overlay */}
            <div className="absolute inset-0 z-20 flex items-center">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                <div className="max-w-2xl animate-fade-in">
                  <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 text-shadow-md">
                    {slide?.title}
                  </h1>
                  <p className="text-xl sm:text-2xl text-white/90 mb-8 text-shadow-sm">
                    {slide?.subtitle}
                  </p>
                  <div className="flex flex-wrap gap-4">
                    <Button
                    variant="default"
                    size="lg"
                    iconName="ShoppingCart"
                    iconPosition="left">

                      {slide?.cta}
                    </Button>
                    <Button
                    variant="outline"
                    size="lg"
                    iconName="MapPin"
                    iconPosition="left"
                    className="bg-white/10 backdrop-blur-sm border-white/30 text-white hover:bg-white/20">

                      View Menu
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Navigation Controls */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-30 w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300"
        aria-label="Previous slide">

        <Icon name="ChevronLeft" size={24} />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-30 w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300"
        aria-label="Next slide">

        <Icon name="ChevronRight" size={24} />
      </button>
      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-30 flex gap-3">
        {heroSlides?.map((_, index) =>
        <button
          key={index}
          onClick={() => goToSlide(index)}
          className={`w-3 h-3 rounded-full transition-all duration-300 ${
          index === currentSlide ?
          'bg-primary w-8' : 'bg-white/50 hover:bg-white/70'}`
          }
          aria-label={`Go to slide ${index + 1}`} />

        )}
      </div>
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-30 hidden sm:flex flex-col items-center gap-2 animate-pulse-subtle">
        <span className="text-white text-sm font-medium">Scroll to explore</span>
        <Icon name="ChevronDown" size={24} color="#FFFFFF" />
      </div>
    </section>);

};

export default HeroSection;